export default "__VITE_ASSET__Bdeyk6Z0__"